export const COMPANY = {
    NAME: 'AurumTours GmbH',
    ADDRESS_LEJ_STREET: 'Querstraße 11',
    ADDRESS_LEJ_CITY: '04103 Leipzig',
};
export const CONTACT = {
    DIGITAL_TOUR_GUIDE_MAIL: 'digitale.reiseleitung@aurumtours.de',
};
